import { jsx as _jsx } from "react/jsx-runtime";
export const Tag = ({ label }) => {
    return _jsx("span", { className: "tag", children: label });
};
